import { isEmpty } from 'lodash';
import { useState } from 'react';

const useForm = (initial = {}) => {
  const [information, setInformation] = useState(initial);
  const [validation, setValidation] = useState(initial);

  const checkAllowSubmit = ({
    information = {},
    validation = {},
    conditions = [],
    skipProps = [],
  }) => {
    const newInformation = { ...information };
    const newValidation = { ...validation };

    if (!isEmpty(skipProps)) {
      for (let prop of skipProps) {
        delete newInformation?.[prop];
        delete newValidation?.[prop];
      }
    }

    // console.log(
    //   `⭐ useForm 👉 checkAllowSubmit ➡️ newInformation ↩`,
    //   newInformation
    // );
    // console.log(
    //   `⭐ useForm 👉 checkAllowSubmit ➡️ newValidation ↩`,
    //   newValidation
    // );
    // console.log(`⭐ useForm 👉 checkAllowSubmit ➡️ conditions ↩`, conditions);
    // console.log(`⭐ useForm 👉 checkAllowSubmit ➡️ skipProps ↩`, skipProps);
    return (
      Object.values(newInformation).every((v) => v) &&
      Object.values(newValidation).every((v) => !v) &&
      (isEmpty(conditions)
        ? true
        : isEmpty(conditions.filter((c) => !Boolean(c))))
    );
  };

  return {
    information,
    setInformation,
    validation,
    setValidation,
    checkAllowSubmit,
  };
};

export default useForm;
